/* @flow */
import gql from 'graphql-tag';

import type {ApolloClient} from 'react-apollo';
import type {HitImage} from '../HitCarouselContainer/HitCarouselContainer';

// npm repo @homeaway/graphql-traveler-property
const query = gql`
    query imagesForListing($listingId: String!) {
        listing(listingId: $listingId) {
            images {
                c6_uri
                altText
            }
        }
    }
`;

type ListingImage = {
    c6_uri: string,
    altText?: string
};

type ListingImagesQueryResponse = {
    data: {
        listing: {
            images?: ListingImage[]
        }
    }
};

type FetchListingImagesParams = {
    client: ApolloClient,
    listingId: string
};

function handleFetchListingImages({
    data: {
        listing: {images}
    }
}: ListingImagesQueryResponse): ?(HitImage[]) {
    return (
        images &&
        images.map((image) => ({
            src: image.c6_uri,
            lowResSrc: image.c6_uri,
            altText: image.altText
        }))
    );
}

export function fetchListingImages({
    client,
    listingId
}: FetchListingImagesParams): Promise<?Array<HitImage>> {
    return client
        .query({
            query,
            variables: {
                listingId
            }
        })
        .then(handleFetchListingImages);
}

export default {
    fetchListingImages
};
